import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [servicesDropdown, setServicesDropdown] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
    setServicesDropdown(false);
  }, [location]);

  // Organized services by categories
  const serviceCategories = [
    {
      category: 'Development',
      items: [
        { name: 'Web Development', path: '/services/web-development' },
        { name: 'Mobile App Development', path: '/services/mobile-apps' },
        { name: 'SaaS Development', path: '/services/saas-development' }
      ]
    },
    {
      category: 'Design & Innovation',
      items: [
        { name: 'UI/UX Design', path: '/services/ui-ux-design' },
        { name: 'AI & Machine Learning', path: '/services/ai-ml' }
      ]
    },
    {
      category: 'Infrastructure & Consulting',
      items: [
        { name: 'Cloud Solutions', path: '/services/cloud-solutions' },
        { name: 'DevOps Services', path: '/services/devops' }
      ]
    },
    {
      category: 'Specialized',
      items: [
        { name: 'MVP Development', path: '/services/mvp-development' },
        { name: 'API Development', path: '/services/api-development' }
      ]
    }
  ];

  return (
    <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
      <div className="navbar-container container">
        <Link to="/" className="navbar-logo">
          SRITHA <span className="black-text">SOLUTIONS</span>
        </Link>

        <div className={`navbar-menu ${isOpen ? 'active' : ''}`}>
          <Link to="/" className="navbar-link">Home</Link>
          
          <div className="dropdown">
            <button 
              className="dropdown-trigger"
              onClick={() => setServicesDropdown(!servicesDropdown)}
            >
              Services <ChevronDown size={16} />
            </button>
            <div className={`dropdown-menu dropdown-menu-mega ${servicesDropdown ? 'show' : ''}`}>
              <div className="dropdown-mega-grid">
                {serviceCategories.map((category, idx) => (
                  <div key={idx} className="dropdown-group">
                    <div className="dropdown-group-title">{category.category}</div>
                    {category.items.map((service, serviceIdx) => (
                      <Link key={serviceIdx} to={service.path} className="dropdown-item">
                        {service.name}
                      </Link>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>

          <Link to="/about" className="navbar-link">About</Link>
          <Link to="/industries" className="navbar-link">Industries</Link>
          <Link to="/careers" className="navbar-link">Careers</Link>
          <Link to="/contact" className="navbar-link contact-btn">Contact</Link>
        </div>

        <button className="menu-toggle" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;